// Origin source from F1M2P5 Button Component,
// Remove ReactSVG because Central-Payment doesn't allow use it for multi-platform purpose
// import button from './button.module.less';
import React from 'react';
const button = {
	sportBtn:"a",
	loading:"b",
	inline:"c",
	ghost:"d"
}
export default class Button extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.filterProps = {};
		Object.keys(this.props).forEach((v) => {
			if (!~[ 'ghost', 'inline', 'radius', 'loading' ].indexOf(v)) {
				this.filterProps[v] = this.props[v];
			}
		});
	}
	componentDidMount() {}
	render() {
		return (
			<button
				{...this.filterProps}
				onClick={this.props.onClick}
				disabled={this.props.disabled}
				className={`${button.sportBtn} ${this.props.ghost ? button.ghost : ''} ${this.props.radius
					? button.radius
					: ''} ${this.props.loading ? button.loading : ''} ${this.props.inline ? button.inline : ''}${this
					.props.className
					? ' ' + this.props.className
					: ''}`}
			>
				<span>
					{this.props.children}
				</span>
				{this.props.fufix ? this.props.fufix : null}
			</button>
		);
	}
}
